import { render } from "./Additional.vue?vue&type=template&id=4179f2ae"
import script from "./Additional.vue?vue&type=script&lang=js"
export * from "./Additional.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__